<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 10px;">
			<el-button @click="handleAdd">添加业务组</el-button>
			<el-button @click="handleBatchImport">批量导入</el-button>
			<el-button @click="exportData">数据导出</el-button>
		</el-col>
		<el-dialog title="批量导入业务组" v-model="batchImportDialogVisible" @close="cancelUpload">
			<el-upload :limit="1"  :on-exceed="handleUploadExceed" :action="uploadUrl"  :on-success="handleUploadSuccess" :on-error="handleUploadError"  :before-upload ="handleBeforeUpload" :headers="uploadHeader" ref="batchImportUpload" :auto-upload="false">
				<span>选取文件:&nbsp;&nbsp;&nbsp;&nbsp;</span><el-button size="small" type="primary">请选择</el-button>
				<a style="display:inline;padding-left:350px;color:#b0b1b3;text-decoration:underline;" v-on:click.stop.prevent="downloadTemplate">模版下载</a>
				<div slot="tip" style="margin-top:55px;" class="el-upload__tip">温馨提示:只能上传excel文件，且不超过20MB</div>
			</el-upload>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelUpload">取 消</el-button>
				<el-button type="primary" @click="batchImportOnSubmit">确 定</el-button>
			</div>
        </el-dialog>
		<!--列表-->
		<el-table :data="list_data" size="mini" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column type="index" width="50">
			</el-table-column>
			<el-table-column prop="groupName" label="名称" width="180" sortable>
			</el-table-column>
			<el-table-column prop="projectNames" label="下辖项目" width="320"  sortable>
			</el-table-column>
			<el-table-column prop="regionCode" label="所属大区" width="100" sortable>
			</el-table-column>
			<el-table-column prop="accountNames" label="关联用户" width="320" sortable>
			</el-table-column>
			<el-table-column label="操作" width="160">
				<template scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">修改</el-button>
					<el-button size="small" @click="handleDeleteOne(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="15" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--编辑界面-->
		<el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
				<el-form-item label="名称" prop="groupName">
					<el-input v-model="editForm.groupName" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item  label="大区"  prop="regionCode">
					<el-select  style="width: 240px" v-model="editForm.regionCode">
						<el-option v-for="i in regionList" :label="i.name" :value="i.code"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" v-bind:disabled="editSubmitButtonDisabled" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--新增界面-->
		<el-dialog title="新增" v-model="addFormVisible" :close-on-click-modal="false" @close="cancelAddSubmit">
			<el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
				<el-form-item label="名称" prop="groupName">
					<el-input v-model="addForm.groupName" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item  label="大区"  prop="regionCode">
					<el-select  style="width: 240px" v-model="addForm.regionCode">
						<el-option v-for="i in regionList" :label="i.name" :value="i.code"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancelAddSubmit">取消</el-button>
				<el-button type="primary" v-bind:disabled="addSubmitButtonDisabled"  @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	import api from '@/api';
	import tools from '@/util/tools';
	import Treeselect from '@riophae/vue-treeselect'
	import global from '@/config/global_config'
	import Vue from 'vue'
	import router from '@/router/index.js'

	export default {
		data() {
			return {
				filters: {
					name: ''
				},
				list_data: [],
				total: 0,
				page: 1,
				listLoading: false,
				sels: [],

				editFormVisible: false,
				editLoading: false,
				editFormRules: {
					name: [
						{ required: true, message: '请输入业务组名称', trigger: 'blur' },
						{ min: 1, max: 32, message: '输入长度在1到32个字符之间'}
					],
					regionCode:[
					    { required: true, message: '请选择大区'},
					],
				},
				editForm: {
					groupName: ''
				},
				addFormVisible: false,
				addLoading: false,
				addFormRules: {
					groupName: [
						{ required: true, message: '请输入业务组名称', trigger: 'blur' },
						{ min: 1, max: 32, message: '输入长度在1到32个字符之间'}
					],
					regionCode:[
					    { required: true, message: '请选择大区'},
					],
				},
				addForm: {
					groupName: ''
				},
				activeName: 'first',
				batchImportDialogVisible:false,
				uploadUrl:global.apiBaseURL+'/bussiessGroup/upload',
				uploadHeader:{access_token:global.getAccessToken()},
				editSubmitButtonDisabled:false,
				addSubmitButtonDisabled:false,
				regionList:[]
			}
		},
		methods: {
			handleCurrentChange(val) {
				this.page = val;
				this.get_list_data();
			},
			handleBatchImport:function () {
				this.batchImportDialogVisible = true;
			},
			downloadTemplate(){
				let param = {};
				api.bussiessGroup_getImportTemplate_request(param).then((res) => {
					let blob = new Blob([res.data],{type:'application/vnd.ms-excel'});
					let fileLink = document.createElement('a')
					fileLink.href = window.URL.createObjectURL(blob);
					fileLink.download =  'template_bussiessGroup'+'_' + new Date().getTime() + '.xls';
					fileLink.click();
                    }).catch(function (e) {
						console.log(e);
						tools.error(new Vue(),e.message);
                    });
			},
			handleUploadExceed(files, fileList){
				console.log('hahahahah');
				tools.error(this,'每次只能上传一个文件!');
				return false
			},
			handleBeforeUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 20;
				if (!isLt2M) {
					tools.error(this,'文件过大,注意不能超过20MB!');
					return false
				}
				let Xls = file.name.split('.');
                if(Xls[1] === 'xls'||Xls[1] === 'xlsx'){
                    return file
                }else {
                    tools.error(this,'上传文件只能是 xls/xlsx 格式!')
                    return false
				}
			},
			batchImportOnSubmit(){
				this.$refs.batchImportUpload.submit();
			},
			handleUploadSuccess(res,file,fileList){
				if(res.code == 200) {
					tools.success(this,"上传成功");
					this.batchImportDialogVisible = false;
					this.$refs.batchImportUpload.clearFiles();
					this.get_list_data();
				}
                else {
					if(res.code == 402) {
						sessionStorage.removeItem('user');
						sessionStorage.removeItem('localRoutes');
						tools.error(new Vue(),'会话已过期,请重新登录');
						router.push('/login');
						location.reload();
					}
					else{
						let errorMessage = '';
						if(res.errorMap){
							Object.keys(res.errorMap).forEach(key => {
								errorMessage += key+"字段:"+res.errorMap[key]+','
							});
							errorMessage = res.msg + '(详细原因：'+ errorMessage +')';
						}
						else errorMessage = res.msg;
						tools.error(new Vue(),errorMessage);
				    }
				}
			},
			handleUploadError(){
				tools.error(this,res.data.msg);
			},
			get_list_data() {
				let param = {
					pageNum: this.page,
					pageSize: 15
				};
				this.listLoading = true;
				api.bussiessGroup_detailList_request(param).then((res) => {
					this.total = res.data.total;
					this.list_data = res.data.list;
					this.listLoading = false;
				}).catch(function (e) {
					console.log(e);
					tools.error(new Vue(),e.message);
                });
			},
			handleDeleteOne: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {showClose:false}).then(() => {
					let param = { ids: row.id };
					api.bussiessGroup_remove_request(param).then(
						res => {
							if(res.code == 200){
								tools.success(this,"删除成功");
							    this.get_list_data();
							}
							else{
								tools.error(new Vue(),res.msg);
							}
						}
					).catch((e) => {
						console.log(e);
						if(e.message)tools.error(new Vue(),e.message);
				    });	
				})
				.catch(function(e) {
					console.log(e);
					if(e.message)tools.error(new Vue(),e.message);
				 });
			},
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);
			},
			handleAdd: function () {
				this.addFormVisible = true;
				this.addForm = {
					groupName: ''
				};
			},
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.editSubmitButtonDisabled=true;
						let param = Object.assign({}, this.editForm);
						this.listLoading = true;
						let self = this;
						api.bussiessGroup_update_request(param).then((res) => {
							this.editFormVisible = false;
							this.$refs.editForm.resetFields();
							this.editSubmitButtonDisabled=false;
							tools.success(this,"编辑成功");
							this.get_list_data();
						}).catch((e) => {
							console.log(e);
							self.editSubmitButtonDisabled=false;
							tools.error(new Vue(),e.message);
						});
						this.listLoading = false;
					}
				});
			},
			addSubmit: function () {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						this.addSubmitButtonDisabled=true;
						let param = Object.assign({}, this.addForm);
						this.listLoading = true;
						let self = this;
						api.bussiessGroup_add_request(param).then((res) => {
							this.addFormVisible = false;
							this.$refs.addForm.resetFields();
							this.addSubmitButtonDisabled=false;
							tools.success(this,"新增成功");
							this.get_list_data();
						}).catch((e) => {
							console.log(e);
							self.addSubmitButtonDisabled=false;
							tools.error(new Vue(),e.message);
						});
						this.listLoading = false;
					}
				});
			},
			handleDataExport:function () {

			},
			selsChange: function (sels) {
				this.sels = sels;
			},
			exportData:function () {
				let param = {
					keys:this.search_word,
				};
				this.listLoading = true;
				api.bussiessGroup_exportData_request(param).then((res) => {
					let blob = new Blob([res.data],{type:'application/vnd.ms-excel'});
					let fileLink = document.createElement('a')
					fileLink.href = window.URL.createObjectURL(blob);
					fileLink.download =  'bussiessGroupList'+'_' + new Date().getTime() + '.xls'
					fileLink.click();
				}).catch((e) => {
					console.log(e);
					tools.error(new Vue(),e.message);
				});
				this.listLoading = false;
			},
			cancelAddSubmit(){
				this.addFormVisible = false;
				this.$refs.addForm.resetFields();
				if(this.addSubmitButtonDisabled)this.addSubmitButtonDisabled = false;
			},
			cancelUpload(){
				this.batchImportDialogVisible = false;
				this.$refs.batchImportUpload.clearFiles();
			},
			getRegionList: function () {
				let param = {};
				this.listLoading = true;
				api.getRegionList(param).then((res) => {
					this.regionList = res.data;
				}).catch(function (e) {
					console.log(e);
				});
				this.listLoading = false;
			}
		},
		mounted() {
			this.get_list_data();
			this.getRegionList();
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// group_list.vue?0a5adfd6